


































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import PacienteConsultaColetivaMiniCard from '../pacientes/PacienteConsultaColetivaMiniCard.vue';
import ConsultaColetivaCancelarDialog from './ConsultaColetivaCancelarDialog.vue';
import PacienteConsultaColetivaCard from '../pacientes/PacienteConsultaColetivaCard.vue';
import { TipoConsultaColetiva } from '../../../../back/src/types';
import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';
import { Consulta } from '../../../../back/src/entity/Consulta';

export default Vue.extend({
  name: 'ConsultaColetivaAlert',
  props: {
    consultaColetiva: {
      type: Object as () => ConsultaColetiva,
    },
  },
  components: {
    PacienteConsultaColetivaMiniCard,
    ConsultaColetivaCancelarDialog,
  },
  data() {
    return {
      tipos: TipoConsultaColetiva,
      carregaTodas: false,
      exibirInicial: 3,
      pacientes: [],
      pacienteSelecionada: null,
    };
  },
  mounted() {
    this.pacientes = _.map(this.consultaColetiva.consultas as Consulta[],
      consulta => consulta.paciente);
  },
  computed: {
    cor() {
      return this.consultaInicioHoje ? 'success' : 'primary';
    },
    icon() {
      return this.carregaTodas ? 'chevron-up' : 'chevron-down';
    },
    iconBtnIniciar() {
      return this.consultaColetiva.started ? 'fa-fw fa-sign-in-alt' : 'fa-fw fa-play';
    },
    textBtnIniciar() {
      return this.consultaColetiva.started ? 'Abrir' : 'Iniciar';
    },
    colorBtnIniciar() {
      return this.consultaColetiva.started ? 'primary' : 'success';
    },
    pacientesExibir() {
      return this.carregaTodas ? this.pacientes : this.pacientes.slice(0, this.exibirInicial);
    },
    numPacientes() {
      return this.pacientes.length;
    },
    dataInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('DD/MM/YYYY');
    },
    dataFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('DD/MM/YYYY');
    },
    horaInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('HH:mm');
    },
    horaFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('HH:mm');
    },
    consultaInicioHoje() {
      return moment().format('DD/MM/YYYY') === this.dataInicio;
    },
    consultaFimHoje() {
      return moment().format('DD/MM/YYYY') === this.dataFim;
    },
    inicioFimMesmoDia() {
      return this.dataInicio === this.dataFim;
    },
  },
  methods: {
    exibirResumoPaciente(paciente) {
      this.$emit('exibir-resumo-paciente', paciente);
    },
  },
});
